import React from 'react';
import { makeStyles } from '@mui/styles';

import { STOPS_SELECTED, X } from '../../constants/strings';
import RouteManagementActionButtons from './RouteManagementActionButtons';
import palette from '../styles/palette';
import { Text } from '../Base';

const useStyles = makeStyles(({ typography }) => ({
  stopsInfo: {
    height: typography.pxToRem(30),
    borderRadius: 4,
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-end',
    justifyContent: 'center',
    width: typography.pxToRem(183),
    background: palette.typography.black.disabled,
  },
  stopInfoTitle: {
    fontWeight: 500,
    fontSize: typography.pxToRem(16),
    color: palette.typography.white.solid,
  },
  stopInfoSeparator: {
    margin: typography.pxToRem(10),
    fontSize: typography.pxToRem(12),
    color: palette.typography.white.medium,
  },
}));

const BottomOptions = ({
  selectedStops,
  isParcelDetails,
  buttonsActionConfig,
  customStyle,
}) => {
  const classes = useStyles();
  const isSelectedStop = !!selectedStops.length;

  return (
    <RouteManagementActionButtons
      buttonsConfig={buttonsActionConfig}
      customStyle={customStyle}
    >
      {!isParcelDetails && isSelectedStop && (
        <span className={classes.stopsInfo}>
          <Text noWrap className={classes.stopInfoTitle}>
            {selectedStops.length}
          </Text>
          <Text noWrap className={classes.stopInfoSeparator}>
            {X}
          </Text>
          <Text noWrap className={classes.stopInfoTitle}>
            {STOPS_SELECTED}
          </Text>
        </span>
      )}
    </RouteManagementActionButtons>
  );
};

export default React.memo(BottomOptions);
